/* tslint:disable */
/* eslint-disable */
/**
 * CMA API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReorderComparablePropertiesItem
 */
export interface ReorderComparablePropertiesItem {
    /**
     * 
     * @type {string}
     * @memberof ReorderComparablePropertiesItem
     */
    mlsId: string;
    /**
     * 
     * @type {string}
     * @memberof ReorderComparablePropertiesItem
     */
    mlsSource: string;
}

/**
 * Check if a given object implements the ReorderComparablePropertiesItem interface.
 */
export function instanceOfReorderComparablePropertiesItem(value: object): value is ReorderComparablePropertiesItem {
    if (!('mlsId' in value) || value['mlsId'] === undefined) return false;
    if (!('mlsSource' in value) || value['mlsSource'] === undefined) return false;
    return true;
}

export function ReorderComparablePropertiesItemFromJSON(json: any): ReorderComparablePropertiesItem {
    return ReorderComparablePropertiesItemFromJSONTyped(json, false);
}

export function ReorderComparablePropertiesItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReorderComparablePropertiesItem {
    if (json == null) {
        return json;
    }
    return {
        
        'mlsId': json['mlsId'],
        'mlsSource': json['mlsSource'],
    };
}

export function ReorderComparablePropertiesItemToJSON(json: any): ReorderComparablePropertiesItem {
    return ReorderComparablePropertiesItemToJSONTyped(json, false);
}

export function ReorderComparablePropertiesItemToJSONTyped(value?: ReorderComparablePropertiesItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mlsId': value['mlsId'],
        'mlsSource': value['mlsSource'],
    };
}

